import React from 'react';

import { Clickable } from '../../types';

export interface Props extends Clickable {
  className?: string;
  x?: number;
  y?: number;
}

class Group extends React.Component<Props, any> {
  static defaultProps: Props = {
    x: 0,
    y: 0,
  };

  public render() {
    const { className, onClick, x, y } = this.props;

    return (
      <g
        transform={`translate(${x}, ${y})`}
        className={className}
        {...onClick && { onClick }}
      >
        {this.props.children}
      </g>
    );
  }
}

export default Group;
